export const typesSojProd = {
    GET_SOJ_PROD_SUCCESS:'GET_SOJ_PROD_SUCCESS',
    GET_SOJ_PROD_ERROR:'GET_SOJ_PROD_ERROR',
    GET_SOJ_PROD_BEGIN:'GET_SOJ_PROD_BEGIN'
}
